<template>
	<svg class="icon" :class="iconClass"><use :xlink:href="'#' + icon"></use></svg>
</template>
<script>
export default {
	props: ["icon"],
	computed: {
		iconClass() { return this.icon ? ("icon-" + this.icon) : ""; }
	}
}
</script>
